
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view-all/[slug]",
      function () {
        return require("private-next-pages/view-all/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view-all/[slug]"])
      });
    }
  